import React, { useContext } from 'react';
import {
  Typography,
} from '@mui/material';
import { Notes as NotesIcon } from '@mui/icons-material';
import CardBase from 'components/CardBase';
import CreateProcessContext from 'shared/contexts/CreateProcessContext';
import { DICTIONARY } from 'shared/constants';
import CardHeader from './CardHeader';
import IconRow from './IconRow';
import IconRowCell from './IconRowCell';

const NotesCard: React.FC = () => {
  const { process } = useContext(CreateProcessContext);

  if (!process.employmentData?.notes) {
    return null;
  }

  return (
    <CardBase>
      <CardHeader icon={NotesIcon} title={DICTIONARY.SpecialNotes} />
      <IconRow>
        <IconRowCell type="text">
          <Typography variant="body2">
            {process.employmentData?.notes}
          </Typography>
        </IconRowCell>
      </IconRow>
    </CardBase>
  );
};

export default NotesCard;
